import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("pos_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("pos_token"); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("pos_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    if (user && ["master", "admin"].includes(user.role) && navigator.onLine) {
      try {
        const { data } = await api.post("/backup/auto", { reason: "logout" });
        localStorage.setItem("pos_last_auto_backup", data.created_at);
      } catch {}
    }
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("pos_token");
    setUser(null);
  };

  const can = (...roles) => user && roles.includes(user.role);
  const isViewOnly = user && user.role === "gm";

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout, can, isViewOnly }}>
      {children}
    </AuthContext.Provider>
  );
}
